import { ECode } from "~/_enums/ECode";
import { TApiConfig } from "~/_libs/fetch/fetchConfig";
import { fetchPostJson } from "~/_libs/fetch/fetchPostJson";
import { TGoogleAccount } from "~/_types/TGoogleAccount";

type TOutputDto = {
  code: ECode;
  data: TGoogleAccount[];
};

export async function postCommonGoogleAccounts(
  config: TApiConfig,
): Promise<TOutputDto> {
  return fetchPostJson(`/v5draft/common-google-accounts`, {}, config);
}
